<app-question-base
  [question]="multiMatrixQuestion"
  [isFirstQuestion]="isFirstQuestion"
  [isMatrixQuestion]="true"
  [mandatoryValue]="mandatoryValue"
>
  @if (hasColumnsAndRows) {
    <app-multi-matrix-table
      [multiMatrixQuestion]="multiMatrixQuestion"
      [form]="form!"
      class="multi-matrix-style block w-full"
    ></app-multi-matrix-table>
  }
</app-question-base>
